import { SelectAllState } from "./types";
import { SelectAllActionTypes } from "./types/actionTypes";

const initialState: SelectAllState = {
  oldProduct: {},
  newProduct: {},
  newAttributeGroup: [],
  newDefaultAttribute: [],
  oldDefaultAttribute: [],
  odlAttributeGroup: [],
  differences: [],
  locations: [],
  selectedLocations: [],
  currMenuId: "",
  page: 0,
  isLoading: true,
};

export const selectAllReducer = (
  state = initialState,
  action: any
): SelectAllState => {
  switch (action.type) {
    case SelectAllActionTypes.FETCH_SELECT_ALL_LOCATIONS_ERROR:
      return {
        ...state,
        locations: [],
        isLoading: false,
      };
    case SelectAllActionTypes.FETCH_SELECT_ALL_LOCATIONS_SUCCESS:
      return {
        ...state,
        locations: action.payload,
      };
    case SelectAllActionTypes.FETCH_SELECT_ALL_OLD_PRODUCT_SUCCESS:
      return {
        ...state,
        oldProduct: action.payload?.data?.to_product?.product,
        odlAttributeGroup: action.payload?.data?.to_product?.attribute_groups,
        oldDefaultAttribute:
          action.payload?.data?.to_product?.default_attributes,
        differences: action.payload.data?.differences,
        page: action.payload?.page,
      };

    case SelectAllActionTypes.SET_SELECT_ALL_NEW_PRODUCT:
      return {
        ...state,
        newProduct: action.payload.product,
        newAttributeGroup: action.payload.attribute_groups,
        newDefaultAttribute: action.payload.default_attributes,
      };
    case SelectAllActionTypes.SET_SELECT_ALL_SELECTED_LOCATIONS:
      return {
        ...state,
        selectedLocations: action.payload,
        page: 1,
      };

    case SelectAllActionTypes.SET_OLD_PRODUCT:
      return {
        ...state,
        oldProduct: action.payload,
      };

    case SelectAllActionTypes.CLEAR_SELECT_ALL_PAGE:
      return initialState;

    case SelectAllActionTypes.SUBMIT_SELECT_ALL_PRODUCT_CHANGES_SUCCESS:
      return {
        ...state,
        page:
          state.selectedLocations.length > state.page
            ? state.page + 1
            : state.page,
      };
    case SelectAllActionTypes.SET_SELECT_ALL_LOADER:
      return {
        ...state,
        isLoading: action.payload,
      };

    default:
      return state;
  }
};
